/*
 * Created Date: 16-08-2022, 12:30:17 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { QUIZ_ROUTER_EXAM } from '@App/Quiz/Modules/Exam/configs/const'
import Cookies from 'js-cookie'
import urlcat from 'urlcat'
import { getDataSession, LOCAL_STORAGE } from './Session'
import { isLocalhost } from './Url'

export const showLoadingPage = () => {
	document.getElementById('loading-page').style.display = 'block'
}

export const hideLoadingPage = (timeout = 0) => {
	setTimeout(() => {
		if (document.getElementById('loading-page')) document.getElementById('loading-page').style.display = 'none'
	}, timeout)
}

export const formatAppRouter = (routes = []) => {
	const data = routes.reduce((result, item) => {
		const { routes, auth, settings } = item
		// console.log('============= item', item)
		const mapEachRouter = routes.map(item => {
			const routerAuth = item?.auth ?? []

			return {
				...item,
				auth: [...auth, ...routerAuth],
				settings
			}
		})
		return [...result, ...mapEachRouter]
	}, [])
	return data
}

export const findPathMatching = (path, urlPathName) => {
	const pathToRegex = path => new RegExp(`^${path.replace(/:[^\s/]+/g, '([^/]+)')}$`)
	return path.includes(':') ? pathToRegex(path).test(urlPathName) : path === urlPathName
}

export const redirectExamPlay = exam => {
	window.open(urlcat(`${window.location.origin}/quiz/${QUIZ_ROUTER_EXAM.test}`, { alias: exam.alias }), '_blank')
}

export const androidOrIOS = () => {
	const { userAgent } = navigator
	if (/android/i.test(userAgent)) {
		return 'android'
	}
	if (/iPad|iPhone|iPod/i.test(userAgent)) {
		return 'ios'
	}
}

export const getCookieMarketing = () => {
	const marketing = Cookies.get('marketing')
	if (marketing) {
		return JSON.parse(marketing)
	}
	return {}
}

export const isOpenWebview = () => {
	return getDataSession(LOCAL_STORAGE, 'app_open') === 'web-view'
}

export const blockF12 = () => {
	if (isLocalhost()) {
		return true
	}
	const disabledKeys = ['c', 'C', 'x', 'J', 'u', 'I']
	const showAlert = e => {
		e.preventDefault()
		// return alert("Sorry, you can't view or copy source codes this way!")
		// setIsAlertExitExamScreen(true)
	}
	document.addEventListener('contextmenu', e => {
		showAlert(e)
	})
	document.addEventListener('keydown', e => {
		// calling showAlert() function, if the pressed key matched to disabled keys
		if ((e.ctrlKey && disabledKeys.includes(e.key)) || e.key === 'F12') {
			showAlert(e)
		}
	})
	window.addEventListener('load', function () {
		try {
			!(function t(n) {
				;(`${n / n}`.length === 1 && n !== 0) || function () {}.constructor('debugger')(), t(++n)
			})(0)
		} catch (n) {
			setTimeout(t, 100)
		}
	})
}
